package fr.manyverse.app.domain.util

private val ACCENT_MAP = mapOf(
    'é' to 'e', 'è' to 'e', 'ê' to 'e', 'ë' to 'e',
    'à' to 'a', 'â' to 'a', 'ä' to 'a',
    'ô' to 'o', 'ö' to 'o',
    'ù' to 'u', 'û' to 'u', 'ü' to 'u',
    'î' to 'i', 'ï' to 'i',
    'ç' to 'c',
    'ÿ' to 'y',
    'ñ' to 'n'
)

fun String.normalizeForSearch(): String {
    val lowered = lowercase()
    if (lowered.none { it in ACCENT_MAP }) return lowered
    return buildString(lowered.length) {
        for (char in lowered) append(ACCENT_MAP[char] ?: char)
    }
}

private val SEPARATORS = Regex("[\\s_-]+")

// Clé de comparaison de noms : « Lance-flèche », « lance_fleche » et « LANCE  FLÈCHE » sont égaux.
// Doit rester alignée avec public.normalize_item_name (schema_bdd.sql)
fun String.normalizeForMatching(): String =
    normalizeForSearch().replace(SEPARATORS, " ").trim()
